import { css } from 'styled-components';
import { FontSize8, FontSize16, FontSize24, Spacing2, Spacing4, Spacing6 } from 'autogen/design-tokens/tokens';
import { mediaQueryStyling } from 'helpers/mediaQueryStyling';
import type { avatarSizeKeys, avatarSizesObject } from './shared/types';

export const avatarSizes = {
    sm: css`
        height: 20px;
        width: 20px;
        font-size: ${FontSize8};
    `,
    md: css`
        height: 40px;
        width: 40px;
        font-size: ${FontSize16};
    `,
    lg: css`
        height: 80px;
        width: 80px;
        font-size: ${FontSize24};
    `
};

export type StyleSizeType = typeof avatarSizes;
export const badgeSize: StyleSizeType = {
    sm: css`
        bottom: 0;
        right: -${Spacing4};
        width: 10px;
        height: 10px;
    `,
    md: css`
        bottom: ${Spacing2};
        right: -${Spacing4};
        width: 16px;
        height: 16px;
    `,
    lg: css`
        bottom: ${Spacing4};
        right: -${Spacing6};
        width: 30px;
        height: 30px;
    `
};

type MappedBreakpointStyling<X, Y> = {
    [P in keyof X]: Y[keyof Y];
};

function getAvatarSizesMediaQueryStyling(styleSizeObject: StyleSizeType, breakpointObject: avatarSizesObject) {
    const breakpointStyling: MappedBreakpointStyling<avatarSizesObject, StyleSizeType> = (
        Object.keys(breakpointObject) as (keyof avatarSizesObject)[]
    ).reduce((acc, key) => {
        const mappedKey = breakpointObject[key];

        if (mappedKey) {
            acc[key] = styleSizeObject[mappedKey];
        }
        return acc;
    }, {});

    return mediaQueryStyling(breakpointStyling);
}

const sizeStyling = css<{ styleSizeObject: StyleSizeType; size: avatarSizesObject | avatarSizeKeys }>`
    ${({ size, styleSizeObject }) =>
        styleSizeObject &&
        size &&
        (typeof size === 'object' ? getAvatarSizesMediaQueryStyling(styleSizeObject, size) : styleSizeObject[size])}
`;

export default sizeStyling;
